import { ApiResponse } from '../models/api-response.models';

export type ApiEnvelope<T> = ApiResponse<T> | T;

export class ApiResponseError extends Error {
  readonly errors: ApiResponse<unknown>['errors'];
  readonly traceId: string | null | undefined;

  constructor(response: ApiResponse<unknown>) {
    super(response.message || 'Request failed.');
    this.name = 'ApiResponseError';
    this.errors = response.errors;
    this.traceId = response.traceId;
  }
}

export function unwrapApiResponse<T>(response: ApiEnvelope<T>): T {
  if (isApiResponse<T>(response)) {
    if (!response.success) {
      throw new ApiResponseError(response as ApiResponse<unknown>);
    }

    return response.data as T;
  }

  return response;
}

export function apiMessage<T>(response: ApiEnvelope<T>, fallback: string): string {
  if (isApiResponse<T>(response)) {
    return response.message || fallback;
  }

  if (typeof response === 'object' && response !== null && 'message' in response) {
    const message = (response as { message?: unknown }).message;
    return typeof message === 'string' && message.trim() ? message : fallback;
  }

  return fallback;
}

export function isApiResponse<T>(response: ApiEnvelope<T>): response is ApiResponse<T> {
  return (
    typeof response === 'object' &&
    response !== null &&
    'success' in response &&
    'message' in response &&
    'data' in response
  );
}
